module.exports = __webpack_public_path__ + "static/media/logo.bd82fa1a.png";